export default {
  getCount: (state) => {
    return state.count
  },
  getName: (state) => {
    return state.name
  },
  userInfo: (state) => {
    return state.userInfo
  },
  activityInfo: (state) => {
    return state.activityInfo
  },
  beltList: (state) => {
    return state.beltList
  },
  applyId: state => {
    return state.applyId
  },
  baseUrl: state => {
    return process.env.NODE_ENV === 'production' ? state.baseUrl : state.baseDevUrl
  },
  productList: state => {
    return state.productList
  },
  applyGiftMaterialList: state => {
    return state.applyGiftMaterialList
  },
  contentVenderLabelList: state => {
    return state.contentVenderLabelList
  },
  couponList: state => {
    return state.couponList
  },
  promotionList: state => {
    return state.promotionList
  },
  langFlag: state => {
    return state.langFlag
  },
  activitySearchObj: state => state.activitySearchObj,
  marketSearchObj: state => state.marketSearchObj,
  inviteShopList: state => state.inviteShopList,
  inMicroApp: state => {
    return state.inMicroApp
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js